// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import PlaceholderOption from './placeholder-option';

function handleChange(event) {

    if (this.alwaysCallOnChange) {

        this.onChange(event.target.value);

    } else if (event.target.value) {

        this.onChange(event.target.value);

    }

}

function handleClick(e) {

    e.message = 'block';

}

const SelectList = props =>
    <select
        className='options-drop-down'
        onChange={props::handleChange}
        onClick={handleClick}
        value={props.selectedValue}
    >
        {props.showPlaceholder &&
            <PlaceholderOption
                isTranslated={props.isPlaceholderTranslated}
                text={props.placeholder}
            />
        }
        {props.options.map((option, index) =>
            <option
                key={index}
                value={option[props.optionKey]}
            >
                {props.optionDisplayAttributes
                    .map(attribute => option[attribute])
                    .join(' - ')
                }
            </option>
        )}
    </select>;

SelectList.displayName = 'SelectList';
SelectList.propTypes = {
    alwaysCallOnChange: PropTypes.bool.isRequired,
    isPlaceholderTranslated: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    optionDisplayAttributes: PropTypes.arrayOf(PropTypes.string).isRequired,
    optionKey: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    placeholder: PropTypes.string.isRequired,
    selectedValue: PropTypes.string,
    showPlaceholder: PropTypes.bool
};
SelectList.defaultProps = {
    showPlaceholder: true
};

export default SelectList;



// WEBPACK FOOTER //
// ./src/shared/components/options-drop-down/select-list.js